/**
 * Service slider titles: below md, one line with a space when it fits; from md up, a deliberate line break.
 */
export function SlideTitleLines({ line1, line2 }: { line1: string; line2: string }) {
  return (
    <>
      {line1}
      <span className="md:hidden"> </span>
      <br className="hidden md:block" aria-hidden />
      {line2}
    </>
  )
}
